/* ==========================================================================
   BBC — Classification automatique du catalogue
   Deduit coupe / occasion / valeur / categorie a partir du vendor, du titre
   et de la description. Aucun tag admin requis.
   Expose window.BBCClassifier.load() -> Promise<Array>
   ====================================================================== */
(function () {
  "use strict";

  var CACHE_KEY = "bbc_products_classified_v1";

  var VENDOR_MAP = {
    "my tailor is joh": "mytailorisjoh",
    "la 8e fois": "la8efois",
    "le manoir a lingerie": "manoirlingerie",
    "teran conde paris": "terancondeparis",
    "colette s'apprete": "colettesapprete",
    "colette sapprete": "colettesapprete",
    "marianne by marie jordane": "mariannebymariejordane"
  };

  var KEYWORD_RULES = {
    coupe: {
      ajustee: ["ajuste", "reglable", "adaptable", "ajustement", "cintre", "pres du corps"],
      fluide: ["fluide", "ample", "drape", "flottant", "vaporeux"],
      structuree: ["structure", "tailleur", "blazer", "rigide", "epaule"]
    },
    occasion: {
      ceremonie: ["mariage", "gala", "ceremonie", "grand soir"],
      soiree: ["soiree", "evenement", "cocktail"],
      quotidien: ["quotidien", "bureau", "casual", "tous les jours"]
    },
    valeur: {
      exclusivite: ["deadstock", "haute couture", "piece unique", "edition limitee", "limitee", "unique"],
      artisanat: ["esat", "atelier", "fait-main", "fait main", "cousu main", "savoir-faire", "brode", "brodee"],
      fonctionnel: ["ajustable", "systeme", "brevet", "patente", "modulable"]
    },
    categorie: {
      lingerie: ["soutien-gorge", "bonnet", "lingerie", "maintien"],
      bijoux: ["collier", "bracelet", "boucles d'oreilles", "boucle d'oreille", "creole", "bijou", "bijoux"]
    }
  };

  var LINGERIE_RENFORT = ["grand bonnet", "forte poitrine", "maintien renforce", "large cup"];

  var BIJOUX_MATIERE = {
    cristaux: ["cristaux autrichiens", "cristal"],
    pierres: ["pierres naturelles", "pierre naturelle"],
    nacre: ["perles de nacre", "nacre"]
  };

  function normalize(str) {
    return String(str || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  function stripHtml(html) {
    var d = document.createElement("div");
    d.innerHTML = String(html || "");
    return d.textContent || "";
  }

  function has(text, list) {
    for (var i = 0; i < list.length; i++) {
      if (text.indexOf(list[i]) !== -1) return true;
    }
    return false;
  }

  function classifyProduct(product) {
    var text = normalize(product.title + " " + stripHtml(product.body_html));
    var vendorKey = normalize(product.vendor);
    var variants = product.variants || [];
    var variant = variants[0] || {};

    var tags = {
      id: product.id,
      title: product.title,
      handle: product.handle,
      vendor: product.vendor,
      image: (product.images && product.images[0] && product.images[0].src) || "",
      available: variants.some(function (v) { return v.available; }),
      marque: VENDOR_MAP[vendorKey] || "autre",
      coupe: null,
      occasion: null,
      valeur: null,
      categorie: null,
      matiereBijou: null,
      lingerieRenfort: false,
      prix: parseFloat(variant.price || 0),
      rawText: text
    };

    Object.keys(KEYWORD_RULES).forEach(function (dimension) {
      var options = KEYWORD_RULES[dimension];
      Object.keys(options).forEach(function (tagValue) {
        if (has(text, options[tagValue])) tags[dimension] = tagValue;
      });
    });

    if (has(text, LINGERIE_RENFORT) || vendorKey === "le manoir a lingerie") {
      tags.lingerieRenfort = true;
      tags.categorie = "lingerie";
    }

    if (vendorKey.indexOf("colette") === 0) {
      tags.categorie = "bijoux";
      Object.keys(BIJOUX_MATIERE).forEach(function (m) {
        if (has(text, BIJOUX_MATIERE[m])) tags.matiereBijou = m;
      });
    }

    return tags;
  }

  /* Un seul passage de fetch, pagine, au chargement de la page quiz */
  function fetchAll() {
    var out = [];
    function page(n) {
      return fetch("/products.json?limit=250&page=" + n, { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var list = (d && d.products) || [];
          out = out.concat(list);
          if (list.length === 250 && n < 8) return page(n + 1);
          return out;
        });
    }
    return page(1);
  }

  function load() {
    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) {}

    return fetchAll().then(function (products) {
      var classified = products
        .map(classifyProduct)
        .filter(function (p) { return p.available && p.prix > 0; });

      classified.forEach(function (p) {
        if (p.categorie !== "bijoux" && !p.coupe && !p.occasion && !p.valeur) {
          console.info("[BBC quiz] produit non classe :", p.title, "(" + p.vendor + ")");
        }
      });

      var slim = classified.map(function (p) {
        return {
          id: p.id, title: p.title, handle: p.handle, vendor: p.vendor,
          image: p.image, marque: p.marque, coupe: p.coupe, occasion: p.occasion,
          valeur: p.valeur, categorie: p.categorie, matiereBijou: p.matiereBijou,
          lingerieRenfort: p.lingerieRenfort, prix: p.prix,
          rawText: p.rawText.slice(0, 400)
        };
      });

      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(slim)); } catch (e) {}
      return slim;
    });
  }

  window.BBCClassifier = { load: load, normalize: normalize, classifyProduct: classifyProduct };
})();
